'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "eventKey"];
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { jsx as _jsx } from "react/jsx-runtime";
const withSelectedState = WrappedComponent => {
  function WithSelectedState(props) {
    const {
        editor,
        eventKey
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    const [selected, setSelected] = useState(false);
    useEffect(() => {
      const handleEvent = ({
        selected: _selected
      }) => {
        setSelected(!!_selected);
      };
      editor.on(eventKey, handleEvent);
      return () => {
        editor.off(eventKey, handleEvent);
      };
    }, [editor, eventKey]);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
      selected: selected
    }, rest));
  }
  WithSelectedState.propTypes = {
    editor: PropTypes.object.isRequired,
    eventKey: PropTypes.string.isRequired
  };
  WithSelectedState.displayName = `WithSelectedState(${getComponentName(WrappedComponent)})`;
  return WithSelectedState;
};
export default withSelectedState;